export const ASIDE_PORTAL_EVENT = 'aside-portal-content-changed';

export const dispatchAsidePortalContentChanged = (hasContent: boolean) => {
    const event = new CustomEvent(ASIDE_PORTAL_EVENT, {
        detail: { hasContent },
    });
    window.dispatchEvent(event);
};

